
//Types should be in const to avoid typos and duplication since it's a string and could be easily miss spelled
export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const SUB_QUANTITY = 'SUB_QUANTITY';
export const ADD_QUANTITY = 'ADD_QUANTITY';
export const ADD_SHIPPING = 'ADD_SHIPPING';
export const SUB_SHIPPING = 'SUB_SHIPPING';
export const ADD_SHOPNAME = 'ADD_SHOPNAME';
export const DELETE_CART = 'DELETE_CART';
export const UPDATE_ITEM_STATUS = 'UPDATE_ITEM_STATUS';
